import React, { FC } from 'react';
import { MembersFooterCont } from './MembersTableFooter.styles';
import { IPagingInfo } from '../../../../services/surveys';
import Pagination from '../../../Pagination/Pagination';
import RowsPerPage from '../../../RowsPerPage/RowsPerPage';

interface IMembersTableFooter {
  pagingInfo: IPagingInfo;
  applyFilters: (filters: Record<string, string | number | null | undefined>) => void;
}

const MembersTableFooter: FC<IMembersTableFooter> = ({ pagingInfo, applyFilters }) => {
  const { itemsPerPage, pageNo, totalPageCount } = pagingInfo;
  return (
    <MembersFooterCont id="MembersFooterCont">
      <RowsPerPage
        itemsPerPage={Number(itemsPerPage)}
        pagesCount={Number(totalPageCount)}
        menu={['5', '15', '25', '50', '75', '100']}
        customApplyFilters={applyFilters}
      />
      <Pagination
        activePage={Number(pageNo)}
        totalPageCount={Number(totalPageCount)}
        applyFilters={(pageNo: number) => applyFilters({ pageNo })}
      />
    </MembersFooterCont>
  );
};
export default MembersTableFooter;
